import { render } from "./TransformEditor.vue?vue&type=template&id=2e1f0caa&scoped=true&ts=true"
import script from "./TransformEditor.vue?vue&type=script&lang=ts"
export * from "./TransformEditor.vue?vue&type=script&lang=ts"

import "./TransformEditor.vue?vue&type=style&index=0&id=2e1f0caa&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1f0caa"]])

export default __exports__